import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

let BASE_URL_WITHOUT_PROTOCOL = environment.djangoUrl.split('://').filter(i => i.trim() !== '').pop().split(':')[0];
@Injectable({
  providedIn: 'root',
})

/**
 * @deprecated
 */
export class CookieService {
  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  set(key, value, exdays = 31) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();

    // value =
    // typeof value == 'object'
    // ? encodeURI(JSON.stringify(value))
    // : encodeURI(value);
    let cookie;
    if (BASE_URL_WITHOUT_PROTOCOL == 'localhost') {
      cookie = `${key}=${value};${expires};path=/;domain=${BASE_URL_WITHOUT_PROTOCOL}`;
    }
    else {
      cookie = `${key}=${value};${expires};path=/;domain=.${BASE_URL_WITHOUT_PROTOCOL}`;
    }
    document.cookie = cookie;
  }

  get(key) {
    let name = key + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        let value = c.substring(name.length, c.length);
        if (this.isJsonString(value)) {
          return JSON.parse(decodeURI(value));
        } else {
          return decodeURI(value);
        }
      }
    }
    return null;
  }

  remove(key) {
    document.cookie = key + `=;path=/;domain=.${BASE_URL_WITHOUT_PROTOCOL};expires=Thu, 01 Jan 1970 00:00:01 GMT`;
  }
}
